/* =============================================================
   GENZON WATER — THEME JS
   Shopify OS 2.0 Custom Theme
   ============================================================= */

/* ── CART ───────────────────────────────────────────────────── */
const GenzonCart = {

  open() {
    this.refresh().then(() => {
      document.getElementById('cartDrawer')?.classList.add('open');
      document.getElementById('cartOverlay')?.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  },

  close() {
    document.getElementById('cartDrawer')?.classList.remove('open');
    document.getElementById('cartOverlay')?.classList.remove('open');
    document.body.style.overflow = '';
  },

  async refresh() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
      this.updateCount(cart.item_count);
      return cart;
    } catch (e) {
      console.error('Cart fetch failed:', e);
    }
  },

  async add(variantId, qty) {
    qty = qty || 1;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      if (!res.ok) {
        const err = await res.json();
        this.showError(err.description || 'Could not add to cart. Please try again.');
        return;
      }
      await this.refresh();
      this.open();
    } catch (e) {
      console.error('Add to cart failed:', e);
    }
  },

  async change(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await this.refresh();
    } catch (e) {
      console.error('Cart update failed:', e);
    }
  },

  remove(key) { this.change(key, 0); },

  render(cart) {
    const items  = document.getElementById('cartItems');
    const empty  = document.getElementById('cartEmpty');
    const foot   = document.getElementById('cartFoot');
    const total  = document.getElementById('cartTotal');
    if (!items) return;

    if (!cart.items.length) {
      if (empty) empty.style.display = 'block';
      items.style.display = 'none';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (empty) empty.style.display = 'none';
    items.style.display = 'flex';
    if (foot) foot.style.display = 'block';

    items.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <div class="cart-item-img">
          ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy" onerror="this.style.display='none'">` : ''}
        </div>
        <div class="cart-item-info">
          <p class="cart-item-name">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
          <p class="cart-item-price">${GenzonCart.fmt(item.final_line_price)}</p>
          <div class="cart-item-qty">
            <button class="cq-btn" onclick="GenzonCart.change('${item.key}', ${item.quantity - 1})">−</button>
            <span class="cq-num">${item.quantity}</span>
            <button class="cq-btn" onclick="GenzonCart.change('${item.key}', ${item.quantity + 1})">+</button>
          </div>
          <button class="cart-item-remove" onclick="GenzonCart.remove('${item.key}')">Remove</button>
        </div>
      </div>`).join('');

    if (total) total.textContent = GenzonCart.fmt(cart.total_price);
  },

  updateCount(n) {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = n;
      el.style.display = n > 0 ? 'inline-flex' : 'none';
    });
  },

  fmt(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },

  showError(msg) {
    const el = document.getElementById('cartError');
    if (el) { el.textContent = msg; el.style.display = 'block'; setTimeout(() => { el.style.display = 'none'; }, 4000); }
    else { alert(msg); }
  }
};

/* ── PRODUCT PAGE ───────────────────────────────────────────── */

// Gallery thumbnail switching
function switchImg(thumb, src) {
  const main = document.getElementById('mainImg');
  if (main) main.src = src;
  document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
}

// Quantity selector
let productQty = 1;
function changeQty(delta) {
  productQty = Math.max(1, productQty + delta);
  const el = document.getElementById('qtyDisplay');
  if (el) el.textContent = productQty;
  const qInput = document.getElementById('quantityInput');
  if (qInput) qInput.value = productQty;
}

// Add to cart via AJAX (used by sticky bar)
function addToCart() {
  const variantEl = document.querySelector('select[name="id"]');
  if (!variantEl) return;
  const variantId = parseInt(variantEl.value);
  if (!variantId) { GenzonCart.showError('Please select a variant.'); return; }
  const btn = document.querySelector('.sticky-atc-btn');
  if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
  GenzonCart.add(variantId, productQty).finally(() => {
    if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
  });
}

// Smart product form handler:
// - One-time purchase → AJAX add to cart + open drawer (no page redirect)
// - Subscription selected in ReCharge widget → let form submit naturally so ReCharge handles checkout
document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('form[id^="product_form_"]');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {

      // 1. Check ReCharge Classic widget UI — radio button for "subscribe" selected?
      //    ReCharge typically renders <input name="rc_radio" value="subscribe"> or similar
      const subscribeRadio = document.querySelector(
        'input[id="rc_radio_subscribe"]:checked,' +
        'input[name="rc_radio"][value="subscribe"]:checked,' +
        'input[value="subscribe"]:checked,' +
        'input[value="subscription"]:checked'
      );
      if (subscribeRadio) return; // ReCharge handles it naturally

      // 2. Check FormData for subscription fields ReCharge may have injected
      //    (selling_plan = Shopify native; properties[...] = ReCharge Classic)
      const fd = new FormData(this);
      const hasSub =
        (fd.get('selling_plan') && fd.get('selling_plan') !== '') ||
        fd.has('properties[subscription_id]') ||
        fd.has('properties[charge_interval_frequency]') ||
        fd.has('properties[shipping_interval_frequency]') ||
        fd.has('properties[order_interval_frequency]');
      if (hasSub) return; // Subscription data present — let it submit naturally

      // 3. One-time purchase — AJAX add + open cart drawer
      e.preventDefault();
      const variantEl = this.querySelector('select[name="id"]');
      if (!variantEl || !variantEl.value) {
        GenzonCart.showError('Please select a variant.');
        return;
      }
      const qty = parseInt(fd.get('quantity')) || productQty || 1;
      const btn = this.querySelector('button[type="submit"].btn-cart');
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }
      GenzonCart.add(parseInt(variantEl.value), qty).finally(() => {
        if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
      });
    });
  }
});

// Variant dropdown change
function selectVariant(select) {
  const variantInput = document.querySelector('select[name="id"]');
  if (variantInput) variantInput.value = select.value;
  // Update price display if data attributes present
  const option = select.options[select.selectedIndex];
  const priceEl = document.querySelector('.product-price');
  if (priceEl && option.dataset.price) {
    priceEl.textContent = '$' + (parseInt(option.dataset.price) / 100).toFixed(2);
  }
}

// Subscribe toggle
function toggleSub(cb) {
  const freq = document.getElementById('subFreq');
  if (freq) freq.classList.toggle('visible', cb.checked);
}

/* ── ACCORDION ──────────────────────────────────────────────── */
function toggleAcc(btn) {
  const isOpen = btn.classList.contains('open');
  // Close all
  document.querySelectorAll('.accordion-trigger').forEach(b => {
    b.classList.remove('open');
    b.nextElementSibling?.classList.remove('open');
  });
  // Open this one if it was closed
  if (!isOpen) {
    btn.classList.add('open');
    btn.nextElementSibling?.classList.add('open');
  }
}

// Event delegation — works even if Shopify CSP blocks inline onclick attributes
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.accordion-trigger');
  if (btn) toggleAcc(btn);
});

/* ── MOBILE NAV ─────────────────────────────────────────────── */
function toggleMobileNav() {
  const nav = document.getElementById('mobileNav');
  if (nav) nav.classList.toggle('open');
}

/* ── SCROLL ANIMATIONS ──────────────────────────────────────── */
function initScrollAnimations() {
  const selectors = [
    '.section-title', '.section-subtitle', '.product-card', '.feature-item',
    '.step-item', '.journal-card', '.team-member', '.philosophy-img',
    '.philosophy-text', '.care-item', '.stat-block', '.collection-card',
    '.faq-item', '.trust-item', '.filter-card', '.part-card',
    '.gallery-wrap', '.product-info', '.timeline-item', '.value-item',
    '.mission-text', '.sub-banner', '.guide-item', '.help-item',
    '.compat-banner', '.cs-card', '.trust-strip .trust-item'
  ].join(',');

  const els = document.querySelectorAll(selectors);
  if (!els.length) return;

  const obs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });

  els.forEach((el, i) => {
    el.classList.add('fade-in');
    el.style.transitionDelay = (i % 5) * 80 + 'ms';
    obs.observe(el);
  });
}

/* ── CART PAGE ──────────────────────────────────────────────── */
function initCartPage() {
  const form = document.querySelector('form[action="/cart"]');
  if (!form) return;
  // qty buttons on cart page
  document.querySelectorAll('[data-cart-qty]').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.key;
      const delta = parseInt(btn.dataset.delta);
      const display = btn.closest('tr, .cart-page-item')?.querySelector('[data-qty-display]');
      const current = parseInt(display?.textContent || 1);
      const newQty = Math.max(0, current + delta);
      GenzonCart.change(key, newQty).then(() => {
        if (newQty === 0) {
          btn.closest('tr, .cart-page-item')?.remove();
        } else if (display) {
          display.textContent = newQty;
        }
        // Refresh page totals
        location.reload();
      });
    });
  });
}

/* ── INIT ───────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  // Initialise cart count in nav
  GenzonCart.refresh();

  // Open cart on nav icon click (wired up in header section)
  document.getElementById('cartToggle')?.addEventListener('click', (e) => {
    e.preventDefault();
    GenzonCart.open();
  });

  // Close cart overlay
  document.getElementById('cartOverlay')?.addEventListener('click', GenzonCart.close.bind(GenzonCart));

  // Close cart on ESC
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') GenzonCart.close();
  });

  // Open first accordion by default
  const firstAcc = document.querySelector('.accordion-trigger');
  if (firstAcc && !firstAcc.classList.contains('open')) {
    firstAcc.classList.add('open');
    firstAcc.nextElementSibling?.classList.add('open');
  }

  initScrollAnimations();
  initCartPage();
});
